<template>
    <div class="lds-dual-ring" :class="size" :style="{'--color': color}"></div>
</template>

<script>
    export default {
        data() {
            return {
                element: 4
            }
        },

        props: {
            size: {
                type: String,
                validator: (velue) => {
                    return ['small', 'default', 'large'].indexOf(velue) !== -1
                },
                default: () => {
                    return 'small'
                }
            },
            color: {
                type: String,
                default: () => {
                    return 'white'
                }
            }
        }
    }

</script>

<style lang="scss">
    .lds-dual-ring.small {
        width: 30px;
        height: 30px;

        &:after {
            content: " ";
            width: 20px;
            height: 20px;
            margin: 2px;
            display: block;
            border-radius: 50%;
            border: 2px solid var(--color);
            border-color: var(--color) transparent var(--color) transparent;
            animation: lds-dual-ring 1.2s linear infinite;
        }
    }

    .lds-dual-ring.default {
        width: 50px;
        height: 50px;

        &:after {
            content: " ";
            width: 50px;
            height: 50px;
            margin: 4px;
            display: block;
            border-radius: 50%;
            border: 4px solid var(--color);
            border-color: var(--color) transparent var(--color) transparent;
            animation: lds-dual-ring 1.2s linear infinite;
        }
    }

    .lds-dual-ring.large {
        width: 80px;
        height: 80px;

        &:after {
            content: " ";
            width: 70px;
            height: 70px;
            margin: 8px;
            display: block;
            border-radius: 50%;
            border: 8px solid var(--color);
            border-color: var(--color) transparent var(--color) transparent;
            animation: lds-dual-ring 1.2s linear infinite;
        }
    }

    .lds-dual-ring {
        display: inline-block;
    }

    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

</style>
